import { getNavigationRoot } from '../../../store/rootSelector';
import { ApplicationState } from '../../../store/types';

export const getLeftMenuOpen = (state: ApplicationState): boolean => getNavigationRoot(state).leftMenuOpen;

export const getRightMenuOpen = (state: ApplicationState): boolean => getNavigationRoot(state).rightMenuOpen;
